import { render, staticRenderFns } from "./CtaMainBanner.vue?vue&type=template&id=776a8f73"
import script from "./CtaMainBanner.vue?vue&type=script&lang=js"
export * from "./CtaMainBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports